import { SidebarModule } from './tour/sidebar/sidebar.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppUserRoutingModule } from './app-user-routing.module';
import { AppUserComponent } from './app-user.component';


import { FormsModule, ReactiveFormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { DashboardHeaderComponent } from './dashboard-header/dashboard-header.component';
import { MatNativeDateModule } from '@angular/material/core';
import { BulkuploadComponent } from './bulkupload/bulkupload.component';
import { ContactsRoutingModule } from './contacts/contacts-routing.module';
import { TourModule } from './tour/tour.module';
import { UserSidebarComponent } from './user-sidebar/user-sidebar.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    DashboardHeaderComponent,
    AppUserComponent,
    BulkuploadComponent,
    UserSidebarComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatButtonModule,
    MatTabsModule,
    MatIconModule,
    MatChipsModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    // ContactsRoutingModule,
    // TourModule,
    AppUserRoutingModule,
    MatTooltipModule,
    SidebarModule,
    TranslateModule.forChild()
  ],
  providers:[
     {
    provide: MatDialogRef,
    useValue: {}
  },
  ]
})
export class AppUserModule { }
